export default [
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/apps/onboarding/views/Onboarding'),
  },
];
